import { render, staticRenderFns } from "./itemCreateModal.vue?vue&type=template&id=1d1cab38&scoped=true&"
import script from "./itemCreateModal.vue?vue&type=script&lang=js&"
export * from "./itemCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./itemCreateModal.vue?vue&type=style&index=0&id=1d1cab38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1cab38",
  null
  
)

export default component.exports